import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { PaymentCollectionType } from './payment-collection-type';
import { RideRequestLocationDetail } from './ride-request-location-detail';
import { RideRequestType } from './ride-request-type';
import { TransitProgramInfo } from './transit-program-info';

@inheritSerialization(AbstractModel)
export class RideRequestFeedItem extends AbstractModel {
  @autoserialize
  riderId: number;

  @autoserialize
  distanceEstimate: number;

  @autoserialize
  durationEstimate: number;

  @autoserialize
  driverFareEstimate: number;

  @autoserializeAs(RideRequestType)
  rideRequestType: RideRequestType;

  @autoserialize
  activated: boolean;

  @autoserializeAs(Date)
  activatedAt: Date;

  @autoserialize
  incentive: number;

  @autoserializeAs(Date)
  pickupDate: Date;

  @autoserializeAs(RideRequestLocationDetail)
  pickupLocation: RideRequestLocationDetail;

  @autoserializeAs(RideRequestLocationDetail)
  dropoffLocation: RideRequestLocationDetail;

  @autoserialize
  timeZone: string;

  @autoserializeAs(TransitProgramInfo)
  transitProgramInfo: TransitProgramInfo;

  @autoserializeAs(PaymentCollectionType)
  riderPaymentCollectionType: PaymentCollectionType;

  @autoserialize
  polyline: string;

  @autoserialize
  favoriteDriver: boolean;

  get displayDate(): Date {
    return !isNullOrUndefined(this.pickupDate) ? this.pickupDate : this.modifiedDate;
  }

  get driverFareEstimatePlusIncentive() {
    if (!isNullOrUndefined(this.incentive)) {
      return this.driverFareEstimate + this.incentive;
    }
    return this.driverFareEstimate;
  }

  get displayTripDetails(): string {
    if (this.pickupLocation != null && this.dropoffLocation != null && this.pickupDate != null) {
      return this.pickupLocation.display + ' <b>to</b> ' + this.dropoffLocation.display + '<br />';
    } else {
      return 'Error getting trip details';
    }
  }

  static OnDeserialized(instance: RideRequestFeedItem, json: any): void {
    if (!isNullOrUndefined(json['pickupDate'])) {
      instance.pickupDate = DateUtil.deserializeDate(json['pickupDate']);
    }

    if (!isNullOrUndefined(json['activatedAt'])) {
      instance.activatedAt = DateUtil.deserializeDate(json['activatedAt']);
    }
  }
}
